import './index.scss';
import { AllSections } from '../../utils/allSections';

export const Footer = () => {
  return <AllSections />;
};

export default Footer;
